// @ts-nocheck
import React from 'react';
import { VisitedProfile } from './types';

interface Props {
  visitedProfiles: { [username: string]: VisitedProfile };
  isScraperConnected: boolean;
  hasCurrentCommand: boolean;
  onImportProfile: (username: string) => void;
  onViewPosts: (username: string) => void;
  onClearProfile: (username: string) => void;
}

const VisitedProfiles: React.FC<Props> = ({
  visitedProfiles,
  isScraperConnected,
  hasCurrentCommand,
  onImportProfile,
  onViewPosts,
  onClearProfile
}) => {
  const entries = Object.entries(visitedProfiles);
  if (entries.length === 0) return null;

  return (
    <div className="bg-white border border-purple-200 rounded-xl shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-purple-200 bg-purple-50 flex justify-between items-center">
        <h2 className="text-lg font-semibold text-purple-900">Visited Profiles</h2>
        <span className="bg-purple-200 text-purple-700 px-2 py-0.5 rounded text-xs font-bold">
          {entries.length} PROFILES
        </span>
      </div>
      <div className="divide-y divide-purple-100">
        {entries.map(([username, profile]) => (
          <div key={username} className="p-4 hover:bg-purple-50 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {username.charAt(0).toUpperCase()}
                </div>
                <div>
                  <p className="font-bold text-gray-900">@{username}</p>
                  <p className="text-sm text-gray-500">{profile.postCount} posts collected</p>
                </div>
              </div>
              <div className="flex space-x-2">
                {profile.posts && profile.posts.length > 0 && (
                  <button
                    onClick={() => onViewPosts(username)}
                    className="px-4 py-2 bg-indigo-600 text-white text-sm font-bold rounded-lg hover:bg-indigo-500 transition-all"
                  >
                    View Posts
                  </button>
                )}
                <button
                  onClick={() => onImportProfile(username)}
                  disabled={!isScraperConnected || hasCurrentCommand || profile.postCount === 0}
                  className="px-4 py-2 bg-purple-600 text-white text-sm font-bold rounded-lg hover:bg-purple-500 disabled:bg-gray-200 disabled:text-gray-400 transition-all"
                >
                  Import All
                </button>
                <button
                  onClick={() => onClearProfile(username)}
                  className="px-4 py-2 hover:bg-gray-200 text-gray-500 text-sm font-bold rounded-lg transition-all"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VisitedProfiles;
